
document.addEventListener('DOMContentLoaded', function () {
    const plansections = document.querySelectorAll('.bgr-plan');
    const modals = document.querySelectorAll('.modal');
    const modalLinks = document.querySelectorAll('.table-side-columns a');
    const noSelectionText = document.querySelectorAll('.no-selection-text');
    const closeButtons = document.querySelectorAll('.close');
    const accordionToggles = document.querySelectorAll('.filter-accordion-toggle');
    const bgrListTicks = document.querySelectorAll('.bgr-list-tick');
    const bgrListCrosses = document.querySelectorAll('.bgr-list-cross');
    const bgrListBullets = document.querySelectorAll('.bgr-list-bullets');
    let lastFocusedElement;
    document.querySelectorAll('.filter-accordion-toggle').forEach((toggle, index) => {
        toggle.setAttribute('data-instance-id', `instance-${index}`);
    });

    modalLinks.forEach(link => {
        link.addEventListener('click', event => {
            event.preventDefault();
            lastFocusedElement = link;
            const targetModal = document.getElementById(link.getAttribute('data-target'));
            targetModal.style.display = 'block';
        });
    });

    closeButtons.forEach(button => {
        button.addEventListener('click', () => {
            const modal = button.closest('.modal');
            modal.style.display = 'none';
            if (lastFocusedElement) {
                lastFocusedElement.classList.add('tableLastElementFocus');
                lastFocusedElement.focus();
                lastFocusedElement.addEventListener('blur', () => {
                    lastFocusedElement.classList.remove('tableLastElementFocus');
                }, { once: true });
            }
        });
    });

    window.addEventListener('click', event => {
        modals.forEach(modal => {
            if (event.target === modal) {
                modal.style.display = 'none';
                if (lastFocusedElement) {
                    lastFocusedElement.classList.add('tableLastElementFocus');
                    lastFocusedElement.focus();
                    lastFocusedElement.addEventListener('blur', () => {
                        lastFocusedElement.classList.remove('tableLastElementFocus');
                    }, { once: true });
                }
            }
        });
    });

    accordionToggles.forEach((toggle, index) => {
        toggle.setAttribute('data-instance-id', `toggle-${index}`);
        const chipsContainer = toggle.closest('.plan-filter').querySelector('.chips-container');
        chipsContainer.setAttribute('data-instance-id', `container-${index}`);

        if (!toggle.classList.contains('event-added')) {
            toggle.addEventListener('click', () => {
                const instanceId = toggle.getAttribute('data-instance-id').replace('toggle', 'container');
                const targetContainer = document.querySelector(`[data-instance-id="${instanceId}"]`);
                targetContainer.classList.toggle('expanded');
                
                const filterChipClose = toggle.querySelector('.filter-chip-close');
                const filterChipOpen = toggle.querySelector('.filter-chip-open');
                
                if (targetContainer.classList.contains('expanded')) {
                    filterChipClose.style.display = 'none';
                    filterChipOpen.style.display = 'block';
                } else {
                    filterChipClose.style.display = 'block';
                    filterChipOpen.style.display = 'none';
                }
            });
            toggle.classList.add('event-added');
        }
    });

    function updateNoSelectionText() {
        noSelectionText.forEach(text => {
            const section = text.closest('.section');
            if (section) {
                const selectedChips = text.closest('.section').querySelectorAll('.chips.selected');
                const tableSection = text.closest('.section').querySelector('.tiered-benefits-table');
                const showMoreButton = text.closest('.section').querySelector('.showmore');
                const planBlockCTA = text.closest('.section').querySelector('.plan-block-ctn');

                if (selectedChips.length === 0) {
                    text.style.display = 'flex';
                    if (tableSection) {
                        tableSection.style.display = 'none';
                        showMoreButton.style.display = 'none';
                    }
                    planBlockCTA.style.display = 'none';
                } else {
                    text.style.display = 'none';
                    if (tableSection) {
                        tableSection.style.display = 'block';
                        showMoreButton.style.display = 'flex';
                    }
                    isShowMoreVisible(section);
                    planBlockCTA.style.display = 'flex';
                }
            }
        });
    }

    function filterColumns(section) {
        if (section) {
            const selectedChips = section.querySelectorAll('.chips.selected');
            const selectedProducts = Array.from(selectedChips).map(chip => chip.getAttribute('data-product'));
            const tableHeaders = section.querySelectorAll('.tiered-benefits-table thead th');
            const tableRows = section.querySelectorAll('.tiered-benefits-table tbody tr');

            tableHeaders.forEach((th, index) => {
                const product = th.getAttribute('data-product');
                if (!selectedProducts.includes(product) && index !== 0) {
                    th.style.display = 'none';
                    tableRows.forEach(row => {
                        row.cells[index].style.display = 'none';
                    });
                } else {
                    th.style.display = '';
                    tableRows.forEach(row => {
                        row.cells[index].style.display = '';
                    });
                }
            });
        }
    }

    plansections.forEach((section, sectionIndex) => {
        const showMoreButtons = section.querySelectorAll('.showmore');
        const chips = section.querySelectorAll('.chips');

        chips.forEach((chip, chipIndex) => {
            const product = chip.getAttribute('data-product');
            const correspondingCard = section.querySelector('.plan-card[data-product="' + product + '"]');
            chip.setAttribute('data-chip-id', `chip-${sectionIndex}-${chipIndex}`);
            if (correspondingCard) {
                correspondingCard.setAttribute('data-chip-id', `chip-${sectionIndex}-${chipIndex}`);
            }

            // Ensuring the chip event listener is added only once
            if (!chip.classList.contains('event-added')) {
                chip.addEventListener('click', () => {
                    const chipId = chip.getAttribute('data-chip-id');
                    const targetCard = section.querySelector(`.plan-card[data-chip-id="${chipId}"]`);

                    if (chip.classList.contains('selected')) {
                        chip.classList.remove('selected');
                        if (targetCard) {
                            targetCard.style.display = 'none';
                        }
                    } else {
                        chip.classList.add('selected');
                        if (targetCard) {
                            targetCard.style.display = 'block';
                        }
                    }
                    if (section) {
                        filterColumns(section);
                        adjustCardHeights();
                        isShowMoreVisible(section);
                        updateNoSelectionText();
                    }
                });
                chip.classList.add('event-added');
            }

            // Initial display setup based on the selected state
            if (chip.classList.contains('selected')) {
                if (correspondingCard) {
                    correspondingCard.style.display = 'block';
                }
            } else {
                if (correspondingCard) {
                    correspondingCard.style.display = 'none';
                }
            }
        });

        showMoreButtons.forEach((showMoreButton) => {
            const rows = section ? section.querySelectorAll('.tiered-benefits-table tbody tr') : [];
            const initialFeatureLoadCount = parseInt(showMoreButton?.id, 10);

            if (!showMoreButton.classList.contains('event-added')) {
                showMoreButton.addEventListener('click', event => {
                    event.preventDefault();
                    const hiddenRows = section.querySelectorAll('.hidden-row');
                    if (hiddenRows.length > 0) {
                        hiddenRows.forEach(row => {
                            row.classList.remove('hidden-row');
                        });
                        showMoreButton.innerHTML = `${window.ShowLessLabelPlan} <span class="showmore-svg"></span>`;
                        updateShowMoreButtonSvg(showMoreButton);
                        const firstRow = section.querySelector('.tiered-benefits-table tbody tr:first-child');
                        if (firstRow) {
                            firstRow.focus();
                        }
                    } else {
                        for (let i = initialFeatureLoadCount; i < rows.length; i++) {
                            rows[i].classList.add('hidden-row');
                        }
                        showMoreButton.innerHTML = `${window.ShowMoreLabelPlan} <span class="showmore-svg"></span>`;
                        updateShowMoreButtonSvg(showMoreButton);
                    }
                });
                showMoreButton.classList.add('event-added');
            }
            isShowMoreVisible(section);
            updateShowMoreButtonSvg(showMoreButton);
        });

        filterColumns(section);
        adjustCardHeights();
        isShowMoreVisible(section);
        updateNoSelectionText();
    });


    function isShowMoreVisible(section) {
        if (section) {
            const showMoreButton = section.querySelector('.showmore');
            const rows = section ? section.querySelectorAll('.tiered-benefits-table tbody tr') : [];
            const initialFeatureLoadCount = parseInt(showMoreButton?.id, 10);

            if (rows.length <= initialFeatureLoadCount) {
                showMoreButton.style.display = 'none';
            } else {
                showMoreButton.style.display = 'flex';
            }
        }
    }

    function updateShowMoreButtonSvg(button) {
        const svgContainer = button.querySelector('.showmore-svg');
        if (button.textContent.trim().includes(window.ShowMoreLabelPlan)) {
            svgContainer.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M12 17.9999L3.29504 9.29488L4.70504 7.87988L12 15.1699L19.295 7.87988L20.705 9.29488L12 17.9999Z" fill="#0079C8"/>
                </svg>`;
        } else {
            svgContainer.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M19.275 16.12L11.985 8.83L4.69002 16.12L3.27502 14.705L11.985 6L20.69 14.705L19.275 16.12Z" fill="#0079C8"/>
                </svg>`;
        }
    }

    function adjustCardHeights() {
        const cardSections = ['.plan-card-body', '.plan-card-keystat', '.plan-card-body2', '.plan-card-cta'];
        cardSections.forEach(section => {
            let maxHeight = 0;
            const elements = document.querySelectorAll(section);
            elements.forEach(el => {
                if (el.offsetParent !== null) {
                    el.style.height = 'auto';
                    const height = el.offsetHeight;
                    if (height > maxHeight) {
                        maxHeight = height;
                    }
                }
            });
            elements.forEach(el => {
                if (el.offsetParent !== null) {
                    el.style.height = maxHeight + 'px';
                }
            });
        });
        let maxH3Height = 0;
        const h3Elements = document.querySelectorAll('.plan-card h3');
        h3Elements.forEach(el => {
            if (el.offsetParent !== null) {
                el.style.height = 'auto';
                const height = el.offsetHeight;
                if (height > maxH3Height) {
                    maxH3Height = height;
                }
            }
        });
        h3Elements.forEach(el => {
            if (el.offsetParent !== null) {
                el.style.height = maxH3Height + 'px';
            }
        });
    }
    adjustCardHeights();
    window.addEventListener('resize', adjustCardHeights);
});
